/* src/app/admin/user-list/user-list.component.scss */
.client-download {
  padding: 7px 15px;
  min-width: inherit;
  background: transparent;
  border: 1px solid #7d1438;
  color: #7d1438;
  border-radius: 6px;
}
.client-download:hover {
  border: 1px solid black !important;
  cursor: pointer;
}
/*# sourceMappingURL=user-list.component-7DVE5KAL.css.map */
